"use client";
import { configureStore } from "@reduxjs/toolkit";
import brandsAndCategoriesSlice from "../slice/brandsAndCategories";
import cartSlice from "../slice/cart";
import filterSlice from "../slice/filter";
import saleSlice from "../slice/sale";
import userDataSlice from "../slice/userData";

const persistenceMiddleware = (store: any) => (next: any) => (action: any) => {
  next(action);
  localStorage.setItem(
    "__redux__cart__",
    JSON.stringify(store.getState().cart)
  );
  localStorage.setItem(
    "__redux__user__",
    JSON.stringify(store.getState().userData)
  );
  localStorage.setItem(
    "__redux__sales__",
    JSON.stringify(store.getState().sale)
  );
};

export const store = configureStore({
  reducer: {
    cart: cartSlice,
    filter: filterSlice,
    userData: userDataSlice,
    sale: saleSlice,
    brandsAndCategories: brandsAndCategoriesSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(persistenceMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
